import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Wand2, Trash2, Loader2 } from "lucide-react";

const BASE = process.env.REACT_APP_BACKEND_URL;
const TARGETS = [
  { id: "hero", label: "Home page hero image" },
  { id: "30-min", label: "30-Minute Session card" },
  { id: "1-hour", label: "1-Hour Session card" },
  { id: "90-min", label: "1½-Hour Video Call card" },
];

export function AdminIllustrations() {
  const [images, setImages] = useState({});
  const [busy, setBusy] = useState("");
  const load = () => api.get("/branding").then((r) => setImages(r.data.images || {}));
  useEffect(() => { load().catch(() => {}); }, []);

  const generate = async (id) => {
    setBusy(id);
    try { await api.post(`/admin/illustrations/${id}`, null, { timeout: 180000 }); toast.success("Illustration generated"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Generation failed"); }
    finally { setBusy(""); }
  };
  const remove = async (id) => { await api.delete(`/admin/illustrations/${id}`); toast.success("Removed — stock image restored"); load(); };

  return (
    <div className="dg-card rounded-xl p-5" data-testid="admin-illustrations">
      <div className="dg-eyebrow flex items-center gap-2"><Wand2 className="w-3 h-3" /> AI illustrations</div>
      <p className="text-sm text-slate-400 mt-1 mb-4">Generate on-brand images for spots that don't have a real photo yet. Takes up to a minute each. Your own uploaded photos always win in the gallery.</p>
      <div className="grid gap-3 sm:grid-cols-2">
        {TARGETS.map((t) => (
          <div key={t.id} className="rounded-lg border border-slate-800 p-3 flex items-center gap-3" data-testid={`illustration-${t.id}`}>
            <div className="w-20 h-14 rounded bg-slate-900 overflow-hidden grid place-items-center shrink-0">
              {images[t.id] ? <img src={`${BASE}${images[t.id]}`} alt={t.label} className="w-full h-full object-cover" /> : <span className="text-[9px] font-mono text-slate-500">STOCK</span>}
            </div>
            <div className="flex-1 min-w-0 text-sm">{t.label}</div>
            <button onClick={() => generate(t.id)} disabled={!!busy} className="dg-btn-primary rounded-full px-3 py-1.5 text-xs flex items-center gap-1 disabled:opacity-50" data-testid={`gen-${t.id}`}>
              {busy === t.id ? <Loader2 className="w-3 h-3 animate-spin" /> : <Wand2 className="w-3 h-3" />} {images[t.id] ? "Regenerate" : "Generate"}
            </button>
            {images[t.id] && <button onClick={() => remove(t.id)} className="text-slate-400 hover:text-red-400 p-1" data-testid={`del-${t.id}`}><Trash2 className="w-4 h-4" /></button>}
          </div>
        ))}
      </div>
    </div>
  );
}
